module.exports = __webpack_public_path__ + "img/12_111.18b82511.png";